import React from 'react';
import { Option, Question } from '../../types';

interface FormRadioButtonProps {
  question: Question;
  handleChange: (questionKey: string, answer: Option[]) => void;
  errors: Record<string, string>;
  setErrors: (value: Record<string, string>) => void;
  disabled: boolean;
}

const FormRadioButton: React.FC<FormRadioButtonProps> = ({
  question,
  handleChange,
  errors,
  setErrors,
  disabled,
}) => {
  const selectedGuid = question.answer?.[0]?.guid;

  const handleRadioClick = (option: Option) => {
    if (selectedGuid === option.guid) {
      handleChange(question.question_key, []);
    } else {
      handleChange(question.question_key, [option]);
      if (errors[question.question_key]) {
        const next = { ...errors };
        delete next[question.question_key];
        setErrors(next);
      }
    }
  };

  return (
    <div>
      {question.options
        ?.filter((option) => option.active)
        .map((option) => {
          const isChecked = selectedGuid === option.guid;

          return (
            <label key={option.guid} style={{ display: 'block', cursor: 'pointer' }}>
              <input
                id={question.question_key}
                className='question-radio'
                type='radio'
                name={question.question_key}
                value={option.text}
                checked={isChecked}
                onClick={() => handleRadioClick(option)}
                onChange={() => {}}
                disabled={disabled}
              />
              {String(option.text)}
            </label>
          );
        })}

      {errors[question.question_key] && (
        <span className='error-text' style={{ color: 'red', fontSize: '12px' }}>
          {errors[question.question_key]}
        </span>
      )}
    </div>
  );
};

export default FormRadioButton;
